import React, { useState, useRef } from "react";
import { useEffect } from "react";
import Images from "../../../media/images";
import { useDispatch } from "react-redux";
import { isOpen } from "../../../features/staffSidebar/staffSidebarSlice";

const SharePage = () => {

  const [showShare, setShowShare] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    window.screen.width >= 1024 ? setShowShare(true) : setShowShare(false);

  }, []);

  const handleShareMenu = () => {
    setShowShare((prev) => !prev);
    // setShowShare(true)
  };


  return (
    <>
      <div className="z-50 flex  fixed top-[150px] lg:!top-44">
        <div className="flex-col gap-1">
          <div className="">
            <div
            
            // onClick={() => dispatch(isOpen())}
            
            className=" hidden lg:!block">
              <img src={Images.share} className="w-20" alt="" />
            </div>
            <div className="rounded-3xl bg-white lg:!block">
              <div className="-ml-1 flex h-fit w-[50px] flex-col items-center gap-0.5 rounded-3xl border-t-2 border-b-2 border-l-2 border-r-4 border-gray-400 pt-1 pb-5 shadow-gray-500 drop-shadow-2xl md:w-[76px]">
                {/* menu and share btn for mobile */}
                <div className="inline-block justify-start sm:p-2 lg:hidden">
                  {/* menu btn */}
                  <svg
                    onClick={handleShareMenu}
                    className="mx-auto bg-sky-700 w-8 sm:w-10"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#000000"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                  </svg>
                  {/* share btn for mobile screen */}
                  <div className="sticky  top-28 z-40 block w-fit sm:top-36 lg:!hidden">
                    <img
                      onClick={handleShareMenu}
                      src={Images.share}
                      className="w-12 sm:!w-16"
                      alt=""
                    />
                  </div>
                </div>
                {showShare && (
                  <div className="flex-col justify-center">
                    {/* down arrow */}
                    <svg
                      className="text-primary-blue h-5 w-full"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 1200 1200"
                    >
                      <path
                        fill="currentColor"
                        d="M600 1200L131.25 496.875h252.539V0h432.422v496.875h252.539L600 1200z"
                      />
                    </svg>
                    {/* facebook */}

                    <div
                      className="fb-share-button"
                      data-href={'https://gmarg.com/'}
                      data-layout="button"
                      data-size="small"
                    >
                      <a
                        style={{ textDecoration: 'none', color: '#3b5998' }}
                        target="_blank"
                        href={
                          'https://www.facebook.com/sharer/sharer.php?u=https://gmarg.com/about'
                        }
                        className=""
                      >
                        <svg
                          className="border-primary-blue h-8 w-10 rounded-r-xl border-2 border-l-0 py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#1877f2"
                            fillRule="evenodd"
                            d="M0 12.067C0 18.033 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666c.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067Z"
                            clipRule="evenodd"
                          />
                        </svg>

                      </a>
                    </div>


                    {/* viber */}

               

                    <div className="w-full">
                      <a href="viber://forward?text=https://gmarg.com/  " target="_blank" className="bg-ce">
                        <svg
                          className="h-8 w-10 rounded-r-xl border-2 border-l-0 border-purple-600 py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 512 512"
                        >
                          <path
                            fill="purple"
                            d="M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8c8.7-9.4 20.7-23.2 29.8-33.7c82.2 6.9 145.3-8.9 152.5-11.2c16.6-5.4 110.5-17.4 125.7-142c15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1c-6 1.9-61.5 15.7-131.2 11.2c0 0-52 62.7-68.2 79c-5.3 5.3-11.1 4.8-11-5.7c0-6.9.4-85.7.4-85.7c-.1 0-.1 0 0 0c-101.8-28.2-95.8-134.3-94.7-189.8c1.1-55.5 11.6-101 42.6-131.6c55.7-50.5 170.4-43 170.4-43c96.9.4 143.3 29.6 154.1 39.4c35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6c-1.1-22-11.4-32.7-32.6-33.9c-8.6-.5-7.8-13.4.7-12.9c27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3c-8.5-.6-7.6-13.5.9-12.9c58 4.2 88.9 44.1 87.8 92.5c-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1c-.6-81.5-54.9-125.9-120.8-126.4c-8.5-.1-8.5-12.9 0-12.9c73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5c-16.2-12.8-31-27.9-42.4-42.4c-10.3-12.9-20.7-28.2-30.8-46.6c-21.3-38.5-26-55.7-26-55.7c-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9c0 0 12.4 14.8 17.7 22.1c5 6.8 11.7 17.7 15.2 23.8c6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7c14.7 8.3 33.4 21.2 45.8 32.9c7 5.7 8.6 14.4 3.8 23.6z"
                          />
                        </svg>
                      </a>
                    </div>
                    {/* whatsapp */}
                    <div className="w-full">
                      <a

                        href="whatsapp://send?text=https://gmarg.com/"

                        className="">
                        <svg
                          className="h-8 w-10 rounded-r-xl border-2 border-l-0 border-[#00E676] py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 256 259"
                        >
                          <path
                            fill="#00E676"
                            d="m67.663 221.823l4.185 2.093c17.44 10.463 36.971 15.346 56.503 15.346c61.385 0 111.609-50.224 111.609-111.609c0-29.297-11.859-57.897-32.785-78.824c-20.927-20.927-48.83-32.785-78.824-32.785c-61.385 0-111.61 50.224-110.912 112.307c0 20.926 6.278 41.156 16.741 58.594l2.79 4.186l-11.16 41.156l41.853-10.464Z"
                          />
                          <path
                            fill="#FFF"
                            d="M219.033 37.668C195.316 13.254 162.531 0 129.048 0C57.898 0 .698 57.897 1.395 128.35c0 22.322 6.278 43.947 16.742 63.478L0 258.096l67.663-17.439c18.834 10.464 39.76 15.347 60.688 15.347c70.453 0 127.653-57.898 127.653-128.35c0-34.181-13.254-66.269-36.97-89.986ZM129.048 234.38c-18.834 0-37.668-4.882-53.712-14.648l-4.185-2.093l-40.458 10.463l10.463-39.76l-2.79-4.186C7.673 134.63 22.322 69.058 72.546 38.365c50.224-30.692 115.097-16.043 145.79 34.181c30.692 50.224 16.043 115.097-34.18 145.79c-16.045 10.463-35.576 16.043-55.108 16.043Zm61.385-77.428l-7.673-3.488s-11.16-4.883-18.136-8.371c-.698 0-1.395-.698-2.093-.698c-2.093 0-3.488.698-4.883 1.396c0 0-.697.697-10.463 11.858c-.698 1.395-2.093 2.093-3.488 2.093h-.698c-.697 0-2.092-.698-2.79-1.395l-3.488-1.395c-7.673-3.488-14.648-7.674-20.229-13.254c-1.395-1.395-3.488-2.79-4.883-4.185c-4.883-4.883-9.766-10.464-13.253-16.742l-.698-1.395c-.697-.698-.697-1.395-1.395-2.79c0-1.395 0-2.79.698-3.488c0 0 2.79-3.488 4.882-5.58c1.396-1.396 2.093-3.488 3.488-4.883c1.395-2.093 2.093-4.883 1.395-6.976c-.697-3.488-9.068-22.322-11.16-26.507c-1.396-2.093-2.79-2.79-4.883-3.488H83.01c-1.396 0-2.79.698-4.186.698l-.698.697c-1.395.698-2.79 2.093-4.185 2.79c-1.395 1.396-2.093 2.79-3.488 4.186c-4.883 6.278-7.673 13.951-7.673 21.624c0 5.58 1.395 11.161 3.488 16.044l.698 2.093c6.278 13.253 14.648 25.112 25.81 35.575l2.79 2.79c2.092 2.093 4.185 3.488 5.58 5.58c14.649 12.557 31.39 21.625 50.224 26.508c2.093.697 4.883.697 6.976 1.395h6.975c3.488 0 7.673-1.395 10.464-2.79c2.092-1.395 3.487-1.395 4.882-2.79l1.396-1.396c1.395-1.395 2.79-2.092 4.185-3.487c1.395-1.395 2.79-2.79 3.488-4.186c1.395-2.79 2.092-6.278 2.79-9.765v-4.883s-.698-.698-2.093-1.395Z"
                          />
                        </svg>
                      </a>
                    </div>
                    {/* messenger */}
                    <div className="w-full">
                    <a
                      href={`fb-messenger://share?link=https://gmarg.com/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                         <svg
                          className="border-primary-blue h-8 w-10 rounded-r-xl border-2 border-l-0 py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 32 32"
                        >
                          <path
                            fill="blue"
                            d="M0 15.521C0 6.599 6.984 0 16 0s16 6.599 16 15.521c0 8.917-6.984 15.521-16 15.521c-1.615 0-3.172-.214-4.625-.615a1.266 1.266 0 0 0-.854.068l-3.188 1.401a1.282 1.282 0 0 1-1.802-1.135l-.094-2.854a1.281 1.281 0 0 0-.422-.906A15.192 15.192 0 0 1-.001 15.522zm11.094-2.922l-4.693 7.469c-.469.703.427 1.521 1.094 1l5.052-3.828a.944.944 0 0 1 1.161 0l3.729 2.802a2.41 2.41 0 0 0 3.469-.641l4.693-7.469c.469-.703-.427-1.505-1.094-1l-5.052 3.828a.923.923 0 0 1-1.146 0l-3.734-2.802a2.398 2.398 0 0 0-3.479.641z"
                          />
                        </svg>
                    </a>
                    </div>
                    {/* twitter */}
                    <div className="w-full">
                      <a href="https://twitter.com/intent/tweet?text=https://gmarg.com/" target="_blank" className="">
                        <svg
                          className="h-8 w-10 rounded-r-xl border-2 border-l-0 border-[#55ACEE] py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 256 209"
                        >
                          <path
                            fill="#55acee"
                            d="M256 25.45a105.04 105.04 0 0 1-30.166 8.27c10.845-6.5 19.172-16.793 23.093-29.057a105.183 105.183 0 0 1-33.351 12.745C205.995 7.201 192.346.822 177.239.822c-29.006 0-52.523 23.516-52.523 52.52c0 4.117.465 8.125 1.36 11.97c-43.65-2.191-82.35-23.1-108.255-54.876c-4.52 7.757-7.11 16.78-7.11 26.404c0 18.222 9.273 34.297 23.365 43.716a52.312 52.312 0 0 1-23.79-6.57c-.003.22-.003.44-.003.661c0 25.447 18.104 46.675 42.13 51.5a52.592 52.592 0 0 1-23.718.9c6.683 20.866 26.08 36.05 49.062 36.475c-17.975 14.086-40.622 22.483-65.228 22.483c-4.24 0-8.42-.249-12.529-.734c23.243 14.902 50.85 23.597 80.51 23.597c96.607 0 149.434-80.031 149.434-149.435c0-2.278-.05-4.543-.152-6.795A106.748 106.748 0 0 0 256 25.45"
                          />
                        </svg>
                      </a>
                    </div>
                    {/* instagram */}
                    <div className="w-full">
                      <a href="" className="">
                        <svg
                          className="h-8 w-10 rounded-r-xl border-2 border-l-0 border-[#FB3958] py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#fb3958"
                            d="M12 9.52A2.48 2.48 0 1 0 14.48 12A2.48 2.48 0 0 0 12 9.52Zm9.93-2.45a6.53 6.53 0 0 0-.42-2.26a4 4 0 0 0-2.32-2.32a6.53 6.53 0 0 0-2.26-.42C15.64 2 15.26 2 12 2s-3.64 0-4.93.07a6.53 6.53 0 0 0-2.26.42a4 4 0 0 0-2.32 2.32a6.53 6.53 0 0 0-.42 2.26C2 8.36 2 8.74 2 12s0 3.64.07 4.93a6.86 6.86 0 0 0 .42 2.27a3.94 3.94 0 0 0 .91 1.4a3.89 3.89 0 0 0 1.41.91a6.53 6.53 0 0 0 2.26.42C8.36 22 8.74 22 12 22s3.64 0 4.93-.07a6.53 6.53 0 0 0 2.26-.42a3.89 3.89 0 0 0 1.41-.91a3.94 3.94 0 0 0 .91-1.4a6.6 6.6 0 0 0 .42-2.27C22 15.64 22 15.26 22 12s0-3.64-.07-4.93Zm-2.54 8a5.73 5.73 0 0 1-.39 1.8A3.86 3.86 0 0 1 16.87 19a5.73 5.73 0 0 1-1.81.35H8.94A5.73 5.73 0 0 1 7.13 19a3.51 3.51 0 0 1-1.31-.86A3.51 3.51 0 0 1 5 16.87a5.49 5.49 0 0 1-.34-1.81V8.94A5.49 5.49 0 0 1 5 7.13a3.51 3.51 0 0 1 .86-1.31A3.59 3.59 0 0 1 7.13 5a5.73 5.73 0 0 1 1.81-.35h6.12a5.73 5.73 0 0 1 1.81.35a3.51 3.51 0 0 1 1.31.86A3.51 3.51 0 0 1 19 7.13a5.73 5.73 0 0 1 .35 1.81V12c0 2.06.07 2.27.04 3.06Zm-1.6-7.44a2.38 2.38 0 0 0-1.41-1.41A4 4 0 0 0 15 6H9a4 4 0 0 0-1.38.26a2.38 2.38 0 0 0-1.41 1.36A4.27 4.27 0 0 0 6 9v6a4.27 4.27 0 0 0 .26 1.38a2.38 2.38 0 0 0 1.41 1.41a4.27 4.27 0 0 0 1.33.26h6a4 4 0 0 0 1.38-.26a2.38 2.38 0 0 0 1.41-1.41a4 4 0 0 0 .26-1.38V9a3.78 3.78 0 0 0-.26-1.38ZM12 15.82A3.81 3.81 0 0 1 8.19 12A3.82 3.82 0 1 1 12 15.82Zm4-6.89a.9.9 0 0 1 0-1.79a.9.9 0 0 1 0 1.79Z"
                          />
                        </svg>
                      </a>
                    </div>
                    {/* linkedin */}
                    <div className="w-full">
                      <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://gmarg.com/" target="_blank" className="">
                        <svg
                          className="h-8 w-10 rounded-r-xl border-2 border-l-0 border-[#0A66C2] py-0.5 md:!w-16"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                          role="img"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 256 256"
                        >
                          <path
                            fill="#0A66C2"
                            d="M218.123 218.127h-37.931v-59.403c0-14.165-.253-32.4-19.728-32.4c-19.756 0-22.779 15.434-22.779 31.369v60.43h-37.93V95.967h36.413v16.694h.51a39.907 39.907 0 0 1 35.928-19.733c38.445 0 45.533 25.288 45.533 58.186l-.016 67.013ZM56.955 79.27c-12.157.002-22.014-9.852-22.016-22.009c-.002-12.157 9.851-22.014 22.008-22.016c12.157-.003 22.014 9.851 22.016 22.008A22.013 22.013 0 0 1 56.955 79.27m18.966 138.858H37.95V95.967h37.97v122.16ZM237.033.018H18.89C8.58-.098.125 8.161-.001 18.471v219.053c.122 10.315 8.576 18.582 18.89 18.474h218.144c10.336.128 18.823-8.139 18.966-18.474V18.454c-.147-10.33-8.635-18.588-18.966-18.453"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SharePage;
